import axios from 'axios';

const base = '/api/v1/lwadmin/livewire_event';

export function getAllEvents() {
  return axios.get(`${base}s`);
}

export function createOrUpdateEvent(dto) {
  return axios.post(`${base}/${dto.id || ''}`, dto);
}

export function getUnlinkedOrders() {
  return axios.get(`${base}s/orders/unlinked`);
}

export function linkOrderToUser(orderId, userId) {
  return axios.post(`${base}s/order/${orderId}/_link_to_user/${userId}`);
}
